import { format, isAfter, parse } from 'date-fns';

/**
 * A fatura já parou de acumular? ("Fatura aberta / fechada / paga", CONTEXT.md)
 *
 * Fonte ÚNICA do critério: `computeInvoiceStatus` (invoiceRepository) decide entre
 * `closed` e `open` por aqui, e o passo "Saldo restante" do PayInvoiceSheet e a trava do
 * `handleInvoiceRemainder` também — resto de fatura só existe em fatura fechada (ADR 0085,
 * atualização de 17/09/2026).
 *
 * Fechou quando HOJE passou do `closingDate` — o próprio dia do fechamento ainda acumula,
 * mesmo corte do `getInvoiceMonthForDate` (a compra desse dia cai nesta fatura). SÓ a data
 * decide: o status persistido não entra. Depois do primeiro pagamento ele vira
 * `partial`/`overdue` e deixa de dizer se fechou; e um `closed` gravado com `closingDate`
 * ainda no futuro só existe quando o dia de fechamento do cartão mudou e o boot reescreveu a
 * janela (`backfillInvoiceWindows`) — pela regra atual a fatura está ABERTA de novo. Olhar o
 * status aí fazia o sheet perguntar "Saldo restante" e o repositório recusar DEPOIS de gravar o
 * pagamento (o 2º toque pagava em dobro).
 */
export function hasInvoiceClosed(
    invoice: { closingDate: string },
    today: Date = new Date(),
): boolean {
    const todayDate = parse(format(today, 'yyyy-MM-dd'), 'yyyy-MM-dd', new Date());
    return isAfter(todayDate, parse(invoice.closingDate, 'yyyy-MM-dd', new Date()));
}
